import React from 'react';

// import Layout from '../components/layout';
import SEO from '../components/seo';
import handAndMobile from '../images/hand-mobile.svg';
import androidLogo from '../images/android-logo.svg';
import appleLogo from '../images/apple-logo.svg';
import Header from '../components/header';
import Footer from '../components/footer';
function IndexPage() {
  return (
    <div className='flex flex-col justify-between h-screen'>
      <Header />

      <SEO
        keywords={[`gatsby`, `tailwind`, `react`, `tailwindcss`]}
        title='Home'
      />

      <section className='flex'>
        <div className='flex-col flex-1 text-center my-auto'>
          <h1 className='font-bold text-white text-6xl'>Chumen Mobile App</h1>
          <p className='text-3xl text-yellow-200'>We find solutions...</p>
          <button className='bg-green-200 hover:bg-green-300 text-white-800 font-bold py-4 px-8 m-4 rounded-full inline-flex items-center'>
            <img src={androidLogo} className='w-4 h-4 mr-2' />
            <span>Get on Android</span>
          </button>
          <button className='bg-gray-300 hover:bg-gray-400 text-gray-800 font-bold py-4 px-8 m-4 rounded-full inline-flex items-center'>
            <img src={appleLogo} className='w-4 h-4 mr-2' />
            <span>Get on Ios</span>
          </button>
        </div>
        <div className='flex-1 mt-10'>
          <img src={handAndMobile} className='float-right' />
        </div>
      </section>
      <Footer />
    </div>
  );
}

export default IndexPage;
